"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpTypeOptionsGetter = void 0;
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey"));
function OpTypeOptionsGetter(self) {
    return self
        ? self.settings.opTypes.map(opType => ({
            queryFieldKey: QueryFieldKey_1.default.OPS_TYPE,
            id: opType.key,
            title: opType.title,
        }))
        : [];
}
exports.OpTypeOptionsGetter = OpTypeOptionsGetter;
exports.default = OpTypeOptionsGetter;
